import { useLang } from "@/lib/LanguageContext";

export default function Marquee() {
  const { c, lang } = useLang();
  const items = [...c.marquee, ...c.marquee];
  return (
    <section data-testid="marquee" className="relative py-8 border-y border-forest/20 bg-[#1a5e2b] overflow-hidden">
      <div key={lang} className="flex whitespace-nowrap animate-marquee">
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl sm:text-4xl text-cream/85 px-8">{w}</span>
            <span className="rotate-45 inline-block h-2 w-2 bg-gold" />
          </span>
        ))}
      </div>
    </section>
  );
}
